module.exports = __webpack_public_path__ + "static/media/close-grey-white.9868bf0a.png";